// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"37636917","348":"e4c26aac","453":"ed4cf4db","457":"1fe337df","831":"348f9301","842":"3380c511"}[chunkId] + ".chunk.js";
};